import React from 'react'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import DefaultTemplate from './DefaultTemplate'
import 'react-datepicker/dist/react-datepicker.css'
import './datepicker.css'
import pt from 'date-fns/locale/pt'
import PropTypes from 'prop-types'

registerLocale('pt', pt)

const DatePicker = props => (
  <div className='d-none d-md-flex col-12 mt-1 px-0'>
    <ReactDatePicker
      {...props}
      locale='pt'
      dateFormat='dd/MM/yyyy'
      customInput={
        <DefaultTemplate
          name={props.name}
          labelDescription={props.labelDescription}
          value={props.value}
        />
      }
      showMonthDropdown
    />
  </div>
)

DatePicker.propTypes = {
  name: PropTypes.string,
  labelDescription: PropTypes.string,
  value: PropTypes.string
}
export default DatePicker



// WEBPACK FOOTER //
// ./src/features/DatePicker/DatePicker.js